import './frame.css'
import './web_component'
import React from 'react'
import { FrameLayoutProps } from './types'

export const Frame: React.FC<FrameLayoutProps> = ({ children, ...props }) => <frame-l {...props}>{children}</frame-l>
